import type {ShopifyIntegrationConfig} from '@cohort/wallet/lib/integrations/shopify';
import {initShopifyConfig} from '@cohort/wallet/lib/integrations/shopify';
import type {InitParamsWDto} from '@cohort/wallet-schemas/init';

export type IntegrationsConfig = ShopifyIntegrationConfig;

export default function parseIntegrationConfig(
  config: InitParamsWDto
): IntegrationsConfig | undefined {
  if (config.integrationType === 'shopify') {
    return initShopifyConfig(config);
  }
  return undefined;
}
